import { useQuery } from '@tanstack/react-query';
import { ORDER_STATUS_TYPE_ENUM, ORDER_STATUSES_SUBORDER_ALL_KEY } from 'modules/sales/settings/order-status/constants';
import { IOrderStatus } from 'modules/sales/settings/order-status/interfaces';
import { OrderStatusService } from 'modules/sales/settings/order-status/services';
import { useTranslation } from 'react-i18next';

const filterUserStatus = (
  data: IOrderStatus[] | undefined,
  value: IOrderStatus,
  excludeTypes?: ORDER_STATUS_TYPE_ENUM[] | string[],
) => {
  // required allowTo value
  if (!data || !data?.length || !value?.type) {
    return [];
  }

  return data
    ?.filter((status) => {
      return value.allowTo?.includes(status?._id as string);
    })
    ?.filter((status) => {
      if (!excludeTypes) return true;
      return !excludeTypes.includes(status.type as ORDER_STATUS_TYPE_ENUM);
    });
};

export const useFindAllOrderStatus = (enabled: boolean = true) => {
  const { i18n } = useTranslation();
  return useQuery<IOrderStatus[]>([ORDER_STATUSES_SUBORDER_ALL_KEY, i18n.language], OrderStatusService.searchAll, {
    staleTime: 60000,
    enabled,
  });
};

export const useFindOneOrderFromCache = (statusId?: any) => {
  const { data, isLoading, error } = useFindAllOrderStatus();
  const status = data?.find((item) => item._id === statusId);

  return {
    status,
    isLoading,
    error,
  };
};

export const useFindOrderStatusForUser = ({
  status,
  excludeTypes,
  enabled = true,
}: {
  status: IOrderStatus;
  excludeTypes?: ORDER_STATUS_TYPE_ENUM[];
  enabled?: boolean;
}) => {
  const query = useFindAllOrderStatus(enabled);
  return {
    orderStatus: filterUserStatus(query.data, status, excludeTypes),
    ...query,
  };
};

export const useFindCancelOrderStatus = () => {
  const { data, isLoading } = useFindAllOrderStatus();
  const status = data?.find((status: any) => status.type === ORDER_STATUS_TYPE_ENUM.CANCELED);
  return { status, isLoading };
};
